import { render, staticRenderFns } from "./ArticleExFire.vue?vue&type=template&id=515c08d2&"
import script from "./ArticleExFire.vue?vue&type=script&lang=js&"
export * from "./ArticleExFire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports